export enum DiagnosisConstants {
  SET_INITIAL_PATIENT_ACUITY = 'diagnosis/SET_INITIAL_PATIENT_ACUITY',
  SET_INITIAL_PATIENT_ACUITY_PNNV = 'diagnosis/SET_INITIAL_PATIENT_ACUITY_PNNV',
  SET_ORGAN_SYSTEM = 'diagnosis/SET_ORGAN_SYSTEM',
  SET_ORGAN_SYSTEM_PNNV = 'diagnosis/SET_ORGAN_SYSTEM_PNNV',
  SET_SYMPTOMS = 'diagnosis/SET_SYMPTOMS',
  SET_SYMPTOMS_PNNVS = 'diagnosis/SET_SYMPTOMS_PNNVS',
  SET_IMPRESSIONS = 'diagnosis/SET_IMPRESSIONS',
  SET_IMPRESSIONS_PNNV = 'diagnosis/SET_IMPRESSIONS_PNNV',
  SET_ANATOMIC_LOCATION = 'diagnosis/SET_ANATOMIC_LOCATION',
  SET_ANATOMIC_LOCATION_PNNV = 'diagnosis/SET_ANATOMIC_LOCATION_PNNV',
  SET_WORKING_DIAGNOSIS = 'diagnosis/SET_WORKING_DIAGNOSIS',
  SET_FINAL_PATIENT_ACUITY = 'diagnosis/SET_FINAL_PATIENT_ACUITY',
  SET_FINAL_PATIENT_ACUITY_PNNV = 'diagnosis/SET_FINAL_PATIENT_ACUITY_PNNV',
  SET_CONDITION_AT_DESTINATION = 'diagnosis/SET_CONDITION_AT_DESTINATION',
  SET_RESPONSE = 'diagnosis/SET_RESPONSE',
  RESET_DIAGNOSIS = 'diagnosis/RESET_DIAGNOSIS',
  SET_DIAGNOSIS_STATE = 'diagnosis/SET_DIAGNOSIS_STATE',
  PRIMARY_SEGMENT_ID = 1,
  SECONDARY_SEGMENT_ID = 2,
  OTHER_SEGMENT_ID = 99,
  NOT_PRESENT_SEGMENT_ID = -1,
}
